export default "__VITE_ASSET__BgCGHRJg__"